import {ListaEncomendaComponent} from './encomenda/lista-encomenda.controller';
import {RomaneioComponent} from './romaneio/romaneio.controller';
import {ColetaColaboradorComponent} from './coleta/colaborador/coleta-colaborador.component';
import {ColetaEnderecoComponent} from './coleta/endereco/coleta-endereco.component';
import {ColetaObservacaoComponent} from './coleta/observacao/coleta-observacao.component';

(function() {
  'use strict';

  function config ($stateProvider) {
    $stateProvider
    // route to show our pedido (/pedido)
      .state('pedido', {
        url: '/pedido?tour',
        template: require('./pedido.html'),
        controller: 'PedidoCtrl',
        redirectTo: 'pedido.encomendas',
        data: {
          headerMenuItems: [
            {
              icon: 'collection:collection',
              text: 'IMPORTAR E AGENDAR',
              state: 'pedido.encomendas',
            },
            {
              icon: 'packages:collections',
              text: 'HISTÓRICO DE COLETAS',
              state: 'lista-pedidos'
            },
            {
              icon: 'packages:list',
              text: 'ROMANEIO',
              state: 'pedido.romaneio'
            },
            // {
            //   icon: 'menu:settings',
            //   text: 'CONFIGURAÇÃO DE COLETAS',
            //   state: 'configuracao-coleta'
            // }
          ],
        }
      })
      .state('lista-pedidos', {
        parent: 'pedido',
        url: '/historico',
        template: require('../historico/pedidos/historico-pedidos.html'),
        controller: 'HistoricoPedidosCtrl as vm',
        authenticate: true,
        data: {
          pageTitle: 'Mandaê - Histórico de pedidos'
        }
      })
      .state('configuracao-coleta', {
        parent: 'pedido',
        component: 'appProfilePickup',
        url: '/configuracao?showSetupDialog',
        authenticate: true,
        data: {
          pageTitle: 'Mandaê - A solução logística para o seu e-commerce'
        }
      })
      // nested states
      // each of these sections will have their own view
      // url will be nested (/pedido/encomenda)
      .state('pedido.encomenda', {
        abstract: true,
        url: '/encomenda',
        template: require('./encomenda/encomenda.html'),
        controller: 'EncomendaCtrl as vm',
        authenticate: true
      })
      // url will be pedido/encomenda/adicionar
      .state('adicionar', {
        parent: 'pedido.encomenda',
        url: '/adicionar',
        component: 'appEncomendaAdicionar',
        authenticate: true,
        data: {
          pageTitle: 'Mandaê - Adicione sua encomenda'
        },
        params: {
          confirmarEndereco: null,
          dadosUsuario: null,
          errorToken: null
        }
      })
      // url will be pedido/encomenda/123/editar
      .state('editar', {
        parent: 'pedido.encomenda',
        url: '/{idEncomenda:[0-9]{1,8}}/editar',
        template: require('./encomenda/encomenda-adicionar.html'),
        controller: 'EncomendaEditarCtrl',
        authenticate: true,
        data: {
          pageTitle: 'Mandaê - Edite sua encomenda'
        }
      })
      // url will be pedido/encomendas
      .state('pedido.encomendas', {
        url: '/encomendas?collectionTour',
        component: 'appListaEncomenda',
        params: {
          retornoDaEdicao: false,
          encomendasAdicionadas: null
        },
        authenticate: true,
        data: {
          pageTitle: 'Mandaê - Lista de encomendas'
        }
      })
      // url will be pedido/romaneio
      .state('pedido.romaneio', {
        url: '/romaneio',
        component: 'appRomaneio',
        authenticate: true,
        data: {
          pageTitle: 'Mandaê - Romaneio de Encomendas'
        }
      })
      // url will be pedido/rastreamento/123
      // .state('rastreamento', {
      //   parent: 'pedido',
      //   url: '/rastreamento/{idEncomenda:[0-9]{1,8}}',
      //   template: require('./rastreamento/rastreamento.html'),
      //   controller: 'RastreamentoCtrl',
      //   data: {
      //     pageTitle: 'Mandaê | Rastrear sua encomenda'
      //   }
      // })
      // url will be pedido/veiculo
      .state('pedido.veiculo', {
        url: '/veiculo',
        template: require('./veiculo/veiculo.html'),
        controller: 'VeiculoCtrl as vm',
        authenticate: true,
        data: {
          pageTitle: 'Mandaê - Escolha um veículo'
        },
        params: {
          origem: null,
          enderecoAtivo: null,
          areaAtuacao: null
        }
      })
      // url will be /pedido/pagamento
      .state('pedido.pagamento', {
        url: '/pagamento',
        template: require('./pagamento/pagamento.html'),
        controller: 'PagamentoCtrl',
        authenticate: true,
        params: {
          estado: false
        },
        data: {
          pageTitle: 'Mandaê - Escolha como pagar'
        }
      })
      // url will be /pedido/resumo
      .state('pedido.resumo', {
        url: '/resumo',
        template: require('./resumo/resumo-pedido.html'),
        controller: 'ResumoPedidoCtrl as vm',
        authenticate: true,
        data: {
          pageTitle: 'Mandaê - Resumo do pedido'
        }
      })
      // url will be /pedido/importar
      .state('importar', {
        url: '/pedido/importar-do-mercado-livre',
        template: require('./mercado-livre/mercado-livre.html'),
        controller: 'ImportarMercadoLivreCtrl as vmIML',
        authenticate: true,
        data: {
          pageTitle: 'Mandaê - Importar encomendas do Mercado Livre'
        }
      })

    // url will be /pedido/importacao/planilha
    .state('importacao-upload', {
      url: '/pedido/importacao/planilha/upload',
      template: require('./importacao-planilha/upload/upload.html'),
      controller: 'UploadImportPlaniCtrl as vm',
      authenticate: true,
      data: {
        pageTitle: 'IMPORTAÇÃO DE PLANILHAS'
      }
    })
    .state('pedido.redirecionar', {
      url: '/redirecionar',
      controller: 'PerfilRedirecionarController',
      template: require('../perfil/redirecionar/redirecionar.html'),
      authenticate: true
    })
      .state('pedido-detalhe', {
        parent: 'pedido',
        url: '/detalhe/{idPedido:[0-9]{1,8}}',
        template: require('../historico/pedido/historico-pedido.html'),
        controller: 'HistoricoPedidoCtrl',
        authenticate: true,
        params: {
          acabouDeFinalizar: false
        },
        data: {
          pageTitle: 'Mandaê - Historico Pedido '
        }
      })
      .state('acompanhamento_por_numero', {
        url: '/pedido/historico?numero=',
        controller: 'PesquisarPedidoPorNumeroCtrl'
      })
      // url will be /historico/pedido/historico-pedido-confirmação
      .state('confirmacao', {
        parent: 'pedido-detalhe',
        url: '/confirmacao',
        template: require('../historico/pedido/historico-pedido-confirmacao/historico-pedido-confirmacao.html'),
        controller: 'HistoricoPedidoConfirmacaoCtrl',
        authenticate: true
      })
      // url will be /historico/pedido/historico-pedido-localizacao
      .state('localizacao', {
        parent: 'pedido-detalhe',
        url: '/localizacao',
        template: require('../historico/pedido/historico-pedido-localizacao/historico-pedido-localizacao.html'),
        controller: 'HistoricoPedidoLocalizacaoCtrl',
        authenticate: true
      })
      // url will be /historico/pedido/historico-pedido-retirada
      .state('retirada', {
        parent: 'pedido-detalhe',
        url: '/retirada',
        template: require('../historico/pedido/historico-pedido-retirada/historico-pedido-retirada.html'),
        controller: 'HistoricoPedidoRetiradaCtrl',
        params: {
          pedido: null
        },
        authenticate: true
      })
      // url will be /historico/pedido/historico-pedido-empacotamento
      .state('empacotamento', {
        parent: 'pedido-detalhe',
        url: '/empacotamento',
        template: require('../historico/pedido/historico-pedido-empacotamento/historico-pedido-empacotamento.html'),
        controller: 'HistoricoPedidoEmpacotamentoCtrl',
        params: {
          pedido: null
        },
        authenticate: true
      })
      // url will be /historico/pedido/historico-pedido-envio
      .state('envio', {
        parent: 'pedido-detalhe',
        url: '/envio',
        template: require('../historico/pedido/historico-pedido-envio/historico-pedido-envio.html'),
        controller: 'HistoricoPedidoEnvioCtrl',
        params: {
          pedido: null
        },
        authenticate: true
      })
      // url will be /historico/pedido/historico-pedido-incompleto
      .state('incompleto', {
        parent: 'pedido-detalhe',
        url: '/incompleto',
        template: require('../historico/pedido/historico-pedido-incompleto/historico-pedido-incompleto.html'),
        controller: 'HistoricoPedidoIncompletoCtrl',
        authenticate: true,
        data: {
          pageTitle: 'Mandaê - Pedido incompleto'
        }
      })
      // url will be /historico/pedido/historico-pedido-cancelado
      .state('cancelado', {
        parent: 'pedido-detalhe',
        url: '/cancelado',
        template: require('../historico/pedido/historico-pedido-cancelado/historico-pedido-cancelado.html'),
        controller: 'HistoricoPedidoCanceladoCtrl',
        authenticate: true,
        data: {
          pageTitle: 'Mandaê - Pedido cancelado'
        }
      })
      // url will be /historico/pedido/historico-pedido-fora-area
      .state('foraarea', {
        parent: 'pedido-detalhe',
        url: '/foraarea',
        template: require('../historico/pedido/historico-pedido-fora-area/historico-pedido-fora-area.html'),
        controller: 'HistoricoPedidoForaAreaCtrl',
        authenticate: true,
        data: {
          pageTitle: 'Mandaê - Pedido fora da área'
        }
      });
  }

  angular
    .module('mandaeApp')
    .component(ListaEncomendaComponent.componentName, ListaEncomendaComponent)
    .component(RomaneioComponent.componentName, RomaneioComponent)
    .component(ColetaColaboradorComponent.componentName, ColetaColaboradorComponent)
    .component(ColetaEnderecoComponent.componentName, ColetaEnderecoComponent)
    .component(ColetaObservacaoComponent.componentName, ColetaObservacaoComponent)
    .config(config);

}());
